<template>
  <div
    v-if="mode !== ''"
    :is="templateNameSuffix"
    :form="form"
    @toggleIsRegistering="$emit('toggleIsRegistering')"
  />
</template>

<script>
import SimulationFooterAdd from '@/components/Shared/Simulation/SimulationFooterAdd'
import SimulationFooterEdit from '@/components/Shared/Simulation/SimulationFooterEdit'
import SimulationFooterReadonly from '@/components/Shared/Simulation/SimulationFooterReadonly'
import { modes } from '@/vuex/modules/simulation/constants'
import { mapGetters } from 'vuex'

export default {
  name: 'SimulationFooterTemplate',
  components: {
    /* eslint vue/no-unused-components: 0 */
    SimulationFooterAdd,
    SimulationFooterEdit,
    SimulationFooterReadonly,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters('simulation', ['mode']),
    templateNameSuffix() {
      const mode = this.mode
      switch (mode) {
        case modes.ADD:
          return 'SimulationFooterAdd'
        case modes.EDIT:
          return 'SimulationFooterEdit'
        case modes.READONLY:
          return 'SimulationFooterReadonly'
        default:
          return 'SimulationFooterReadonly'
      }
    },
  },
}
</script>
